const fileTypeImagesPrefix = `/assets/images/file-types/`;

export const DefaultFileTypeImage = { id: 6, name: '', imagePath: `${fileTypeImagesPrefix}others.webp` };

export const FileTypeImages = [
  { id: 1, name: '.spr', imagePath: `${fileTypeImagesPrefix}spr.webp` },
  { id: 2, name: '.stl', imagePath: `${fileTypeImagesPrefix}stl.webp` },
  { id: 3, name: '.jpg', imagePath: `${fileTypeImagesPrefix}jpg.webp` },
  { id: 4, name: '.pdf', imagePath: `${fileTypeImagesPrefix}pdf.webp` },
  { id: 5, name: '.png', imagePath: `${fileTypeImagesPrefix}png.webp` },
  { id: 7, name: '.folder', imagePath: `${fileTypeImagesPrefix}folder.svg` },
  { id: 8, name: '.mov', imagePath: `${fileTypeImagesPrefix}mp4.webp` },
  { id: 9, name: '.mp4', imagePath: `${fileTypeImagesPrefix}mp4.webp` },
  DefaultFileTypeImage,
];
